import type { TranslationKey } from '../i18n/translations.js';

type Translate = (key: TranslationKey) => string;

/**
 * "Facebook · Page name". Every place a destination is chosen or listed names
 * its network first, because the same word ("page", "account") means a
 * different thing on each and the lists are read side by side.
 */
export function withChannel(t: Translate, channel: string, name: string, networkName?: string): string {
  return `${networkLabel(t, channel, networkName)} · ${name}`;
}

/**
 * A network's name in the reader's language when there is a translation, and
 * otherwise the name its definition gives — a network added as data has no
 * translation until somebody writes one.
 */
export function networkLabel(t: Translate, network: string, fallback?: string): string {
  const key = `channelName.${network}`;
  const label = t(key as TranslationKey);
  return label === key ? (fallback ?? network) : label;
}
